// pages/SsoCallback.jsx
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Spin } from "antd";
import { motion } from "framer-motion";
import { HiArrowNarrowRight } from "react-icons/hi";
import { ssoCheck, loginPrize } from "../../function/auth";
import logo from "./logo/logo.png";  
import partnerLogo from "./logo/logo-prizemed.jpg";

const SsoCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [needPassword, setNeedPassword] = useState(false);
  const [ssoUser, setSsoUser] = useState({ email: "", name: "" });
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleLoginSuccess = ({ token, username, role, profileImage }) => {
    toast.success(`${username} Login Success`);
    localStorage.setItem("token", token);
    if (role === "employee") navigate("/employ-shop");
    else navigate("/");
    setTimeout(() => window.location.reload(), 500);
  };

  useEffect(() => {
    const code = params.get("code");
    if (!code) {
      toast.error("ไม่พบ code");
      return navigate("/login");
    }

    ssoCheck({ code })
      .then((res) => {
        if (!res.data.needPassword) {
          handleLoginSuccess(res.data);
        } else {
          setSsoUser({ email: res.data.email, name: res.data.name });
          setNeedPassword(true);
          setLoading(false);
        }
      })
      .catch(() => {
        toast.error("เข้าสู่ระบบผ่าน SSO ไม่สำเร็จ");
        navigate("/login");
      });
  }, []);

  const handleSubmitPassword = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await loginPrize({
        username: ssoUser.email,
        password,
      });
      handleLoginSuccess({
        token: res.data.token,
        username: res.data.username,
        role: res.data.role,
        profileImage: res.data.profileImage?.url,
      });
    } catch (err) {
      toast.error("รหัสผ่านไม่ถูกต้อง");
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spin /> <p>กำลังตรวจสอบข้อมูล...</p>
      </div>
    );
  }

  if (needPassword) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f5f5f5",
          padding: "1rem",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 380,
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 3px 20px rgba(0,0,0,0.12)",
            padding: "2rem",
          }}
        >
          {/* Logo connection header */}
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 14,
              marginBottom: "1.5rem",
            }}
          >
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                background: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.17)",
                flexShrink: 0,
              }}
            >
              <img
                src={partnerLogo}
                alt="Partner"
                style={{ width: 36, objectFit: "contain" }}
              />
            </div>

            <motion.div
              animate={{ x: [0, 6, 0] }}
              transition={{ repeat: Infinity, duration: 1.2, ease: "easeInOut" }}
              style={{ color: "#FF70A6", display: "flex" }}
            >
              <HiArrowNarrowRight size={26} />
            </motion.div>

            {/* 360 Healthy Shop */}
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                background: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.17)",
                flexShrink: 0,
              }}
            >
              <img
                src={logo}
                alt="360 Healthy Shop"
                style={{ width: 36, objectFit: "contain" }}
              />
            </div>
          </motion.div>

          <div style={{ textAlign: "center", marginBottom: "1.25rem" }}>
            <h5 style={{ fontWeight: 500, marginBottom: 4 }}>
              ยืนยันตัวตนครั้งแรก
            </h5>
            <p style={{ color: "#888", fontSize: 13, margin: 0 }}>
              สวัสดี {ssoUser.name} กรุณากรอกรหัสผ่านของระบบ PrizeMed
              เพื่อยืนยันตัวตนครั้งแรก
            </p>
          </div>

          <form
            onSubmit={handleSubmitPassword}
            style={{ display: "flex", flexDirection: "column", gap: 10 }}
          >
            <div>
              <label style={{ fontSize: 13, color: "#666", display: "block", marginBottom: 4 }}>
                Email
              </label>
              <input className="form-control" value={ssoUser.email} disabled />
            </div>
            <div>
              <label style={{ fontSize: 13, color: "#666", display: "block", marginBottom: 4 }}>
                Password
              </label>
              <input
                className="form-control"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="btn w-100"
              style={{ background: "#FF70A6", color: "#fff", marginTop: 4 }}
              disabled={submitting}
            >
              {submitting ? <Spin size="small" /> : "ยืนยัน"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return null;
};

export default SsoCallback;